import {AngularEditorConfig} from '@kolkov/angular-editor';

export const TOOLBAR_HIDDEN_BUTTONS = [['undo',
    'redo', 'strikeThrough',
    'subscript',
    'superscript', 'justifyLeft',
    'justifyCenter',
    'justifyRight',
    'justifyFull',
    'indent',
    'outdent',
  ], ['fontSize', 'customClasses',
    'removeFormat',
    'textColor',
    'backgroundColor',
    'unlink',
    'insertImage',
    'insertVideo']];
export const EDITOR_CONFIG: AngularEditorConfig = {
  editable: true,
  height: 'auto',
  minHeight: '10rem',
  minWidth: '55rem',
  enableToolbar: true,
  showToolbar: true,
  sanitize: true,
  toolbarPosition: 'top',
  toolbarHiddenButtons: TOOLBAR_HIDDEN_BUTTONS
};

export const CONFIRMATION_TEXTS = {
  acceptClaimRequest: 'Are you sure you want to ACCEPT this claim request ?',
  rejectClaimRequest: 'Are you sure you want to REJECT this claim request ?',
};

export const APP_ROUTES = {
  login: '/login',
};
